var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PartnerMonthlyEmployerReport',_vm._b({},'PartnerMonthlyEmployerReport',{
    partnerId: _vm.partnerId,
    selectableBillingPeriods: _vm.selectableBillingPeriods,
    employers: _vm.employers,
    periodsLoaded: _vm.periodsLoaded,
    loadBillingPeriodsByPartner: _vm.loadBillingPeriodsByPartner,
    resetBillingPeriodsState: _vm.resetBillingPeriodsState,
    downloadReportForPartner: _vm.downloadReportForPartner,
    setPeriod: _vm.setPeriod,
    setEmployer: _vm.setEmployer
  },false))}
var staticRenderFns = []

export { render, staticRenderFns }